import { useParams, useSearchParams } from 'react-router-dom';

import { LocalType, PDFReportType } from '@gameonly/core';
import useUser from '../../authentication/context/useUser';
import { PdfCompleteReport } from '../../pdf/PdfCompleteReport';
import {
  getPaginatedResultsByCategories,
  getProjectYear,
  processPaginatedResults,
  resultHasData,
} from '../../pdf/utils';
import { getResultsToDisplay } from '../../results/Results';
import { useProject } from '../context/useProject';

const ProjectPdf = () => {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const localType = searchParams.get('localType') as LocalType;
  const reportType = searchParams.get('reportType') as PDFReportType;

  const { user } = useUser();
  const { project } = useProject(projectId);
  const model = project?.model;

  if (!project || !user || !model) {
    return null;
  }

  const year = getProjectYear(project);

  const reportDate = new Date();
  const reportResults = project.results;

  const filters = localType ? [localType] : undefined;

  const resultsWithData = reportResults.filter(resultHasData); // CHECK IF NECESSARY
  const resultsToDisplay = getResultsToDisplay(resultsWithData, filters);
  let paginatedResults = getPaginatedResultsByCategories(
    resultsToDisplay,
    model,
    reportType,
    project.name
  );

  if (!paginatedResults) return null;

  // add page numbers
  paginatedResults = processPaginatedResults(paginatedResults);

  return (
    <PdfCompleteReport
      key={project._id.toString()}
      paginatedResults={paginatedResults}
      year={year}
      reportDate={reportDate}
      model={model}
    />
  );
};

export default ProjectPdf;
